var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"paging"},[_c('el-pagination',{attrs:{"background":"","layout":"prev, pager, next","current-page":_vm.currentPage ? _vm.currentPage : 1,"total":_vm.total,"page-size":_vm.pageSize},on:{"current-change":_vm.handleCurrentChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }